import API from '@/apiRequest';

// Actions
const ACTIONS = {
  SYNC: 'inspectors/SYNC',
};

// Reducer
const initialState = [];
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ACTIONS.SYNC:
      return action.payload.map(item => ({ value: item, label: item }));
    default:
      return state;
  }
}

// Actions
export const syncInspectors = () => async dispatch => {
  try {
    const { data: inspectors } = await API.get('inspectors/name');

    dispatch({
      type: ACTIONS.SYNC,
      payload: inspectors,
    });
  } catch (err) {
    dispatch({
      type: ACTIONS.SYNC,
      payload: null,
    });
  }
};
